import AppApi from '../AppApi';
import { getPublicClientGuidFromLocalStorage, sessionKeys } from '../localStorage';
import { addQueryParam } from '../../lib/utils';

const appApi = new AppApi();

const createFullUrl = (path: string): string => {
	const clientGuid = getPublicClientGuidFromLocalStorage();
	const queryParams = [{ key: sessionKeys.publicClientUniqueId, value: clientGuid }];
	return addQueryParam(path, queryParams);
};

export const get = async <T>(path: string, signal?: AbortSignal): Promise<T> => {
	const fullUrl = createFullUrl(path);
	return appApi.ajax('get', fullUrl, null, signal, false);
};

export const post = async <T>(path: string, data: unknown, signal?: AbortSignal): Promise<T> => {
	const fullUrl = createFullUrl(path);
	return appApi.ajax('post', fullUrl, data, signal, false);
};

export const put = async <T>(path: string, data: unknown, signal?: AbortSignal): Promise<T> => {
	const fullUrl = createFullUrl(path);
	return appApi.ajax('put', fullUrl, data, signal, false);
};

export const httpDelete = async <T>(path: string, signal?: AbortSignal): Promise<T> => {
	const fullUrl = createFullUrl(path);
	return appApi.ajax('delete', fullUrl, null, signal, false);
};
